{
    "keys": {
        "authors": {
            "min": 0,
            "max": 1000
        }, 
        "articles": {
            "min": 1001,
            "max": 10000000000
        },
        "components": {
            "min": 10000000000,
            "max": 100000000000000000000,
            "big_red_button": {
                "min": 10000000000,
                "max": 10000000100
            },
            "link_container": {
                "min": 10000000101,
                "max": 10000002101
            },
            "article": {
                "min": 10000002102,
                "max": 15000002102,
                "text": {
                    "min": 15000002103,
                    "max": 20000002103
                }
            },
            "missing_3": {
                "min": 20000002104,
                "max": 20000002106
            },
            "writers_widget": {
                "min": 20000002107,
                "max": 20000012107
            },
            "home_page": {
                "min": 20000012108,
                "max": 25000012108
            },
            "writer_page": {
                "min": 25000012109,
                "max": 30000012109
            },
            "article_page": {
                "min": 30000012110,
                "max": 35000012110
            }
        }
    }
}